var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10844",
    "data-name": "Group 10844",
    transform: "translate(-364 -297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2063",
    "data-name": "Rectangle 2063",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(364 297)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2066",
    "data-name": "Rectangle 2066",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(368 297)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2069",
    "data-name": "Rectangle 2069",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(372 297)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2062",
    "data-name": "Rectangle 2062",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(364 301)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2065",
    "data-name": "Rectangle 2065",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(368 301)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2068",
    "data-name": "Rectangle 2068",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(372 301)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(364 305)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2064",
    "data-name": "Rectangle 2064",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(368 305)",
    fill: "#2e80c0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2067",
    "data-name": "Rectangle 2067",
    width: 3,
    height: 2,
    rx: 1,
    transform: "translate(372 305)",
    fill: "#2e80c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridBlue);
export default __webpack_public_path__ + "static/media/gridBlue.f94bdcb5868a3da22b49fe4d41a936d9.svg";
export { ForwardRef as ReactComponent };